import { reactive, readonly } from 'vue';

import { BillingInteraction } from '@/types/billing';

type PendingInteraction = Pick<BillingInteraction, 'cta' | 'event_site'>;

type LegacyConnectorUpgradeModalState = {
  isVisible: boolean;
  pendingInteraction: PendingInteraction | null;
};

const state = reactive<LegacyConnectorUpgradeModalState>({
  isVisible: false,
  pendingInteraction: null,
});

export function useLegacyConnectorUpgradeModal() {
  function openModal(pendingInteraction: PendingInteraction) {
    state.isVisible = true;
    state.pendingInteraction = pendingInteraction;
  }

  function closeModal() {
    state.isVisible = false;
    state.pendingInteraction = null;
  }

  return {
    state: readonly(state),
    openModal,
    closeModal,
  };
}
